"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var Types = require("types");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var ProgressText_1 = require("../GenericFileUploadModal/ProgressText");
var mapStateToProps = function (state) {
    var uploadedFiles = Object.values(state.fileUploadModal.uploadedFiles);
    return {
        currentUploadStatus: state.fileUploadModal.currentUploadStatus,
        uploadHasStarted: uploadedFiles.length > 0,
        allFailed: state.fileUploadModal.currentUploadStatus.allFailed
    };
};
exports.mapStateToProps = mapStateToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps), (0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (this.props.currentUploadStatus.speed !==
            nextProps.currentUploadStatus.speed ||
            this.props.currentUploadStatus.remaining !==
                nextProps.currentUploadStatus.remaining ||
            this.props.currentUploadStatus.uploadPercentage !==
                nextProps.currentUploadStatus.uploadPercentage ||
            this.props.uploadHasStarted !== nextProps.uploadHasStarted ||
            this.props.allFailed !== nextProps.allFailed) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
exports.default = enhance(function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("div", { className: 'container' }, props.uploadHasStarted && !props.allFailed && (React.createElement(React.Fragment, null,
        React.createElement(ProgressText_1.ProgressText, { key: 'progress-text', speed: props.currentUploadStatus.speed, remaining: props.currentUploadStatus.remaining, uploadDone: props.currentUploadStatus.uploadPercentage === 100, allDone: props.currentUploadStatus.allDone }),
        React.createElement(sok_ui_1.ProgressBar, { key: 'progress-bar', percent: props.currentUploadStatus.uploadPercentage, doneText: (0, translation_1.getLocalization)('userfront/project/files/genericFileUploadModal/doneText') })))))); });
